import imageCompression from 'browser-image-compression';

// Compress an image File before upload. Returns a File (or original on error).
// Tunable defaults pick a sensible balance between quality and PDF render speed.
export async function compressImageFile(file, opts = {}) {
  if (!file || !file.type?.startsWith('image/')) return file;
  // Skip compression for tiny files (already smaller than target).
  if (file.size <= 350 * 1024) return file;
  try {
    return await imageCompression(file, {
      maxSizeMB: opts.maxSizeMB ?? 1.0,
      maxWidthOrHeight: opts.maxWidthOrHeight ?? 1920,
      useWebWorker: true,
      initialQuality: opts.quality ?? 0.85,
      fileType: opts.fileType,
    });
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Image compression failed, uploading original:', e);
    return file;
  }
}
